import * as React from 'react';

import Icon from 'components/atoms/Icon';
import TutorialArrow from 'components/molecules/Tutorial/TutorialArrow';
import i18n from 'helper/i18n';

const TutorialFeedCalendar = () => (
	<React.Fragment>
		<TutorialArrow />
		<h2 className="m-tutorial__title">{i18n('react.impulsCoach.components.tutorialFeedCalendar.title')}</h2>
		<p className="m-tutorial__text">{i18n('react.impulsCoach.components.tutorialFeedCalendar.text')}</p>
		<ul className="m-tutorial-content">
			<li className="m-tutorial-content__item">
				<span className="m-tutorial-content__icon">
					<div className="a-counter">
						<span className="a-counter__number">
							{i18n('react.impulsCoach.components.tutorialFeedCalendar.countNumber')}
						</span>
					</div>
				</span>
				<span className="m-tutorial-content__text">
					{i18n('react.impulsCoach.components.tutorialFeedCalendar.list.1')}
				</span>
			</li>
			<li className="m-tutorial-content__item">
				<span className="m-tutorial-content__icon">
					<div className="m-tutorial-icon m-tutorial-icon--filled">
						<div className="m-tutorial-icon__inner">
							<Icon iconName={'completed'} />
						</div>
					</div>
				</span>
				<span className="m-tutorial-content__text">
					{i18n('react.impulsCoach.components.tutorialFeedCalendar.list.2')}
				</span>
			</li>
			<li className="m-tutorial-content__item">
				<span className="m-tutorial-content__icon">
					<div className="m-tutorial-icon" />
				</span>
				<span className="m-tutorial-content__text">
					{i18n('react.impulsCoach.components.tutorialFeedCalendar.list.3')}
				</span>
			</li>
		</ul>
	</React.Fragment>
);

export default TutorialFeedCalendar;
